// @ts-nocheck

import { createApp, nextTick } from 'vue'
// import { createLocalVue, mount } from '@vue/test-utils'

import App from './App.vue'
import {CmpApi} from '@iabgpp/cmpapi';
import {TCModel, TCString, GVL} from '@iabtechlabtcf/core';

import {CmpApi as TCFCmpApi} from '@iabtechlabtcf/cmpapi';


import {getVisitorCountryAndRegion, isGDPRCountry} from './geo'
import {getParameterByName, ampLogInfo, ampLogError, getCookie, setCookie, setCookieWithExpireTime, CookieOptions} from './util'

import { isGpcEnabled } from './gpc'
import { applyGpcToUsSections } from './applyGpc'
import './smokeTests/gpcSmokeTest'

import {
  TcfEuV2, 
  UsCa as UsCaV1, 
  UsCo as UsCoV1, 
  UsCt as UsCtV1, 
  UsUt as UsUtV1, 
  UsVa as UsVaV1,
  UsDe,
  UsIa,
  UsNe,
  UsNh,
  UsNj,
  UsOr,
  UsTn,
  UsTx,
  UsMt
} from '@iabgpp/cmpapi'

import {
  updateCMPColorado, 
  updateCMPCalifornia, 
  updateCMPConnecticut, 
  updateCMPUtah, 
  updateCMPDelaware, 
  updateCMPIowa, 
  updateCMPMontana, 
  updateCMPNebraska, 
  updateCMPNewHampshire, 
  updateCMPNewJersey, 
  updateCMPOregon, 
  updateCMPTennessee, 
  updateCMPTexas, 
  updateCMPVirginia 
} from './components/updateCMPFuncs.js'

const CMP_BUILD = 238;
const CMP_ID = 77;
const CMP_VERSION = 5; // Bumped due to TCF 2.3 disclosed vendors fix
const CMP_CONSENTCOOKIE = "euconsent-v2";
const CMP_NONTCFCONSENTCOOKIE = "euconsent-v2-non-tcf";

const CMP_GPP_CONSENTCOOKIE = "amp-gpp-consent-string";

declare const gGDPR_publisherCountryCode: string;

const __gppMountDivID = "__cmp_mount";
let __gppAppInstance = null;

// Expose debug globals for DevTools access
declare global {
  interface Window {
    cmpApi: any;
    __cmpApi: any;
    __gppAppInstance: any;
    __cmpTCModel: any;
    __GVL: any;
    __cmpSetDisclosedVendorIds: (vendorIds: number[]) => void;
    __gppOpenUI: () => void;
    __tcfapi: any;
    __gpp: any;
  }
}

// -------------------------------
// TCF 2.3: Disclosed Vendors helper
// -------------------------------

// (Optional) The UI ca set this with vendors that really were showed to the user
let __cmpDisclosedVendorIds = null;

/**
 * UI can call this to inform which TCF vendor IDs were displayed (disclosed).
 * Only vendors participating in IAB TCF (GVL vendors) should be included here.
 */
window.__cmpSetDisclosedVendorIds = function (vendorIds) {
  if (!Array.isArray(vendorIds)) {
    __cmpDisclosedVendorIds = null;
    return;
  }
  __cmpDisclosedVendorIds = vendorIds
    .map((v) => Number(v))
    .filter((v) => Number.isFinite(v) && v > 0);
};

/**
 * Apply disclosed vendor IDs to TCModel (TCF 2.3 requirement).
 * If no IDs are provided, fallback can optionally setAllVendorsDisclosed().
 */
function __applyDisclosedVendorsToModel(disclosedVendorIds) {
  if (!window.__cmpTCModel || !window.__cmpTCModel.vendorsDisclosed) return;

  const vd = window.__cmpTCModel.vendorsDisclosed;

  // clear existing disclosed vendors
  if (typeof vd.unsetAll === 'function') {
    vd.unsetAll();
  } else if (vd.set_ && typeof vd.set_.clear === 'function') {
    vd.set_.clear();
    vd.maxId_ = 0;
    vd.bitLength = 0;
  }

  // If UI passed explicit vendor IDs (preferred)
  const ids = Array.isArray(disclosedVendorIds) ? disclosedVendorIds : __cmpDisclosedVendorIds;

  if (Array.isArray(ids) && ids.length > 0) {
    for (const id of ids) vd.set(Number(id));
    return;
  }

  // Fallback: if you truly disclose ALL GVL vendors in your UI, keep this:
  if (typeof window.__cmpTCModel.setAllVendorsDisclosed === 'function') {
    window.__cmpTCModel.setAllVendorsDisclosed();
  }
}

/**
 * Ensure TCModel consistency before encoding to TC String.
 * TCF 2.3 requires:
 * - policyVersion aligned with GVL tcfPolicyVersion
 * - isServiceSpecific=false to ensure DisclosedVendors segment is included
 * - vendorsDisclosed populated with all GVL vendors
 * 
 * Note: When isServiceSpecific=true, some encoder paths omit the DisclosedVendors
 * segment. Setting it to false ensures the segment is always included for TCF 2.3 compliance.
 * 
 * Validation: After calling this and encoding, check window.__cmpTCModel.vendorsDisclosed
 * is non-empty and the euconsent-v2 cookie contains the DisclosedVendors segment.
 */
function __ensureTcModelConsistencyBeforeEncode() {
  if (!window.__cmpTCModel) return;

  // Ensure policyVersion matches GVL tcfPolicyVersion
  if (window.__GVL && typeof window.__GVL.tcfPolicyVersion !== 'undefined') {
    window.__cmpTCModel.policyVersion = window.__GVL.tcfPolicyVersion;
  }

  // Force isServiceSpecific=false to ensure DisclosedVendors segment is included
  // This works around a known issue where isServiceSpecific=true can cause the
  // DisclosedVendors segment to be omitted in some encoder implementations
  window.__cmpTCModel.isServiceSpecific = false;

  // Populate vendorsDisclosed with all GVL vendors
  if (window.__GVL && window.__GVL.vendors) {
    if (typeof window.__cmpTCModel.setAllVendorsDisclosed === 'function') {
      window.__cmpTCModel.setAllVendorsDisclosed();
    } else if (window.__cmpTCModel.vendorsDisclosed) {
      const vendorIds = Object.keys(window.__GVL.vendors);
      for (const vendorId of vendorIds) {
        const numericId = Number(vendorId);
        if (Number.isFinite(numericId) && numericId > 0) {
          window.__cmpTCModel.vendorsDisclosed.set(numericId);
        }
      }
    }
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Establish the CMP mount point and inject privacy links and messages
//


function __injectDOMElements( ) {
  
    let existingMountDiv = document.getElementById(__gppMountDivID);
  
    if ( existingMountDiv ) {
  
    }
    else {
      var elemDiv = document.createElement('div');
      elemDiv.id = __gppMountDivID
      document.body.appendChild(elemDiv);
      }
  
    setTimeout( () => {
  
      let onClickCommand = "window.scroll(0,0);__gppOpenUI()"; // todo: make this a function call to the GPP CMP
  
      let privacyElem = document.getElementById('ampCMP_privacyPolicy');
      if ( privacyElem)
        privacyElem.innerHTML = '<h4>Privacy Consent Management</h4><p>You can resurface the consent management platform that will allow you to edit and change your consent choices by clicking this link: <a href="javascript:void(0);" onclick="'+onClickCommand+'">Manage Your Consent</a></p>';
      
      let footerElem = document.getElementById('ampCMP_footer');
      if ( footerElem) {
        footerElem.innerHTML = '<a class="nav-link" href="javascript:void(0);" onclick="'+onClickCommand+'">Privacy Choices</a>';
      }
        
    }, 500);
  
  }
  
window.__gppOpenUI = function() {
  if ( ! __gppAppInstance ) {
    ampLogInfo( "__gppOpenUI():  __gppAppInstance not initialized" );
  } else {
  __gppAppInstance.openCMP();
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

//  Get consent strings in and out of the GPP api and updating them in the cookie and
//  local storage locations

function __storeGPPString( encodedString : string ) : void  {
  ampLogInfo( "__storeGPPString() result = " + encodedString)
  cmpApi.setGppString( encodedString );
  
  // Set GPP cookie with Chrome-compatible attributes
  const isHttps = location.protocol === 'https:';
  const cookieOptions: CookieOptions = {
    path: '/',
    sameSite: isHttps ? 'None' : 'Lax',
    secure: isHttps
  };
  setCookie(CMP_GPP_CONSENTCOOKIE, encodedString, 365, cookieOptions);
}

function __getGPPString(  ) : string  {
  return  cmpApi.getGppString( );
}

function __updateGPPCookie( ) : void  {

  //todo: also set this in local storage
  let gppString = __getGPPString();

  // console.log( "CMP(): __updateGPPCookie() : " + gppString  ) ;

  // Set GPP cookie with Chrome-compatible attributes
  const isHttps = location.protocol === 'https:';
  const cookieOptions: CookieOptions = {
    path: '/',
    sameSite: isHttps ? 'None' : 'Lax',
    secure: isHttps
  };
  setCookie(CMP_GPP_CONSENTCOOKIE, gppString, 365, cookieOptions);

}

function __getGPPCookie(  ) : string  {

  //todo: also get this in local storage

  return getCookie( CMP_GPP_CONSENTCOOKIE );

}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

//  These functions deal with TCF (GDPR) consent strings encoded/decoded by the TCModel class,
//  feeds through to save the encoded consent string in the 'tcfeuv2' GPP section

  function __storeTCString(disclosedVendorIds = null) : void {
    const gppDebug = getParameterByName('ampGPPDebug') === '1';

    console.log('__storeTCString() called');
    
    // Log current purpose consent state
    if (window.__cmpTCModel) {
      const purposes = [];
      for (let i = 1; i <= 11; i++) {
        if (window.__cmpTCModel.purposeConsents.has(i)) {
          purposes.push(i);
        }
      }
      console.log('Current purpose consents:', purposes.join(', ') || 'NONE');
    }

    // TCF 2.3: Disclosed Vendors
    __applyDisclosedVendorsToModel(disclosedVendorIds);

    // Ensure TCModel consistency before encoding (policyVersion, isServiceSpecific=false, vendorsDisclosed)
    // This guarantees the TC String will include the DisclosedVendors segment required by TCF 2.3
    __ensureTcModelConsistencyBeforeEncode();

    // Debug logging for TCF 2.3 compliance
    if (gppDebug && window.__cmpTCModel) {
      const vdSize = window.__cmpTCModel.vendorsDisclosed?.size || 0;
      ampLogInfo(`TCModel before encode: policyVersion=${window.__cmpTCModel.policyVersion}, isServiceSpecific=${window.__cmpTCModel.isServiceSpecific}, vendorsDisclosed.size=${vdSize}`);
    }

    const encodedString = TCString.encode(window.__cmpTCModel);
    console.log('Encoded TC String (first 100 chars):', encodedString.substring(0, 100));

    try {
      const segs = encodedString.split('.').length;
      ampLogInfo(`TC String segments = ${segs} (>=2 for TCF 2.3)`);
    } catch (e) {}

    // Set TCF cookie with Chrome-compatible attributes
    const isHttps = location.protocol === 'https:';
    const cookieOptions: CookieOptions = {
      path: '/',
      sameSite: isHttps ? 'None' : 'Lax',
      secure: isHttps
    };
    
    console.log('Setting cookie:', CMP_CONSENTCOOKIE);
    setCookie(CMP_CONSENTCOOKIE, encodedString, 365, cookieOptions);
    setCookie(CMP_NONTCFCONSENTCOOKIE, "", 365, cookieOptions);
    console.log('Cookie set complete');

    // Verify cookie was set (debug mode)
    if (gppDebug) {
      setTimeout(() => {
        const verification = document.cookie.split('; ').find(x => x.startsWith(`${CMP_CONSENTCOOKIE}=`));
        if (verification) {
          ampLogInfo(`✓ ${CMP_CONSENTCOOKIE} cookie verified in document.cookie (length=${verification.length})`);
        } else {
          ampLogError(`✗ ${CMP_CONSENTCOOKIE} cookie NOT found in document.cookie!`);
        }
      }, 100);
    }

    console.log('Updating CMP APIs with new TC string');
    cmpApi.setSectionString('tcfeuv2', encodedString);

    cmpApi.fireEvent("sectionChanged", 'tcfeuv2');
    cmpApi.setSignalStatus("ready");
    cmpApi.fireEvent('signalStatus', 'ready');

    tcfCmpApi.update(encodedString, false);

    __updateGPPCookie();
    console.log('__storeTCString() complete');
}


function __storeAcceptAllTCString(disclosedVendorIds = null) {
  window.__cmpTCModel.setAll();

  if (typeof gGDPR_NonTCFVendors != "undefined") {
    gGDPR_NonTCFVendors.forEach((element, index, a) => {
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = true;
    });
  }

  __storeTCString(disclosedVendorIds);
}

function __storeRejectAllTCString(disclosedVendorIds = null) {
  ampLogInfo("Reject All");

  window.__cmpTCModel.unsetAll();

  if (typeof gGDPR_NonTCFVendors != "undefined") {
    gGDPR_NonTCFVendors.forEach((element, index, a) => {
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = false;
    });
  }

  __storeTCString(disclosedVendorIds);
}


// //
// // TCF Stub Implementation - Required for CMP Validator to detect __tcfapi
// // This stub will be replaced by the full TCFCmpApi when it loads
//

(function () {
  const makeStub = () => {
    const TCF_LOCATOR_NAME = '__tcfapiLocator';
    const queue = [];
    const currentWindow = window;
    let frameLocator = currentWindow;
    let cmpFrame;
    let gdprApplies;

    function addFrame() {
      const doc = currentWindow.document;
      const otherCMP = !!(currentWindow.frames[TCF_LOCATOR_NAME]);

      if (!otherCMP) {
        if (doc.body) {
          const iframe = doc.createElement('iframe');

          iframe.style.cssText = 'display:none';
          iframe.name = TCF_LOCATOR_NAME;
          doc.body.appendChild(iframe);
        } else {
          setTimeout(addFrame, 5);
        }
      }

      return !otherCMP;
    }

    function tcfAPIHandler(...args) {

      if (!args.length) {
        // Return the queue when the full CMP implementation loads
        return queue;
      } else if (args[0] === 'setGdprApplies') {
        if (args.length > 3 && parseInt(args[1], 10) === 2 && typeof args[3] === 'boolean') {
          gdprApplies = args[3];

          if (typeof args[2] === 'function') {
            args[2]('set', true);
          }
        }
      } else if (args[0] === 'ping') {
        // Respond to ping with stub status
        if (typeof args[2] === 'function') {
          args[2]({
            gdprApplies: gdprApplies,
            cmpLoaded: false,
            cmpStatus: 'stub',
          }, true);
        }
      } else {
        // Queue all other commands for the full CMP implementation
        queue.push(args);
      }
    }

    function postMessageEventHandler(event) {
      const msgIsString = typeof event.data === 'string';
      let json = {};

      if (msgIsString) {
        try {
          json = JSON.parse(event.data);
        } catch (ignore) {
        }
      } else {
        json = event.data;
      }

      const payload = (typeof json === 'object' && json !== null) ? json.__tcfapiCall : null;

      if (payload) {
        window.__tcfapi(
          payload.command,
          payload.version,
          function (retValue, success) {
            let returnMsg = {
              __tcfapiReturn: {
                returnValue: retValue,
                success: success,
                callId: payload.callId,
              },
            };

            if (event && event.source && event.source.postMessage) {
              event.source.postMessage((msgIsString) ? JSON.stringify(returnMsg) : returnMsg, '*');
            }
          },
          payload.parameter,
        );
      }
    }

    // Check for existing __tcfapiLocator frame in parent windows
    while (frameLocator) {
      try {
        if (frameLocator.frames[TCF_LOCATOR_NAME]) {
          cmpFrame = frameLocator;
          break;
        }
      } catch (ignore) {
      }

      if (frameLocator === currentWindow.top) {
        break;
      }

      frameLocator = frameLocator.parent;
    }

    if (!cmpFrame) {
      // No existing CMP found, create stub
      addFrame();
      currentWindow.__tcfapi = tcfAPIHandler;
      currentWindow.addEventListener('message', postMessageEventHandler, false);
    }
  };

  makeStub();

}());



////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
// GPP Stub Implementation... iabgpp-es assumes this is available before
// initialization (code from https://github.com/IABTechLab/iabgpp-es/blob/master/modules/stub/src/stub.js)
//

window.__gpp_supportedAPIs = [
  "2:tcfeuv2",
  "8:usca",
  "9:usva",
  "10:usco",
  "11:usut",
  "12:usct",
  "14:usmt",
  "15:usor",
  "16:ustx",
  "17:usde",
  "18:usia",
  "19:usne",
  "20:usnh",
  "21:usnj",
  "22:ustn",
], 

window.__gpp_addFrame = function (n) {
  if (!window.frames[n]) {
    if (document.body) {
      var i = document.createElement("iframe");
      i.style.cssText = "display:none";
      i.name = n;
      document.body.appendChild(i);
    } else {
      window.setTimeout(window.__gpp_addFrame, 10, n);
    }
  }
};

window.__gpp_stub = function () {
  var b = arguments;
  __gpp.queue = __gpp.queue || [];
  __gpp.events = __gpp.events || [];

  if (!b.length || (b.length == 1 && b[0] == "queue")) {
    return __gpp.queue;
  }

  if (b.length == 1 && b[0] == "events") {
    return __gpp.events;
  }

  var cmd = b[0];
  var clb = b.length > 1 ? b[1] : null;
  var par = b.length > 2 ? b[2] : null;
  if (cmd === "ping") {
    clb(
      {
        gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
        cmpStatus: "stub", // possible values: stub, loading, loaded, error
        cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
        signalStatus: "not ready", // possible values: not ready, ready
        supportedAPIs: window.__gpp_supportedAPIs, // list of supported APIs
        cmpId: CMP_ID, // IAB assigned CMP ID, may be 0 during stub/loading
        sectionList: [],
        applicableSections: [],
        gppString: "",
        parsedSections: {},
      },
      true
    );
  } else if (cmd === "addEventListener") {
    if (!("lastId" in __gpp)) {
      __gpp.lastId = 0;
    }
    __gpp.lastId++;
    var lnr = __gpp.lastId;
    __gpp.events.push({
      id: lnr,
      callback: clb,
      parameter: par,
    });
    clb(
      {
        eventName: "listenerRegistered",
        listenerId: lnr, // Registered ID of the listener
        data: true, // positive signal
        pingData: {
          gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
          cmpStatus: "stub", // possible values: stub, loading, loaded, error
          cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
          signalStatus: "not ready", // possible values: not ready, ready
          supportedAPIs: window.__gpp_supportedAPIs, // list of supported APIs
          cmpId: CMP_ID, // IAB assigned CMP ID, may be 0 during stub/loading
          sectionList: [],
          applicableSections: [],
          gppString: "",
          parsedSections: {},
        },
      },
      true
    );
  } else if (cmd === "removeEventListener") {
    var success = false;
    for (var i = 0; i < __gpp.events.length; i++) {
      if (__gpp.events[i].id == par) {
        __gpp.events.splice(i, 1);
        success = true;
        break;
      }
    }
    clb(
      {
        eventName: "listenerRemoved",
        listenerId: par, // Registered ID of the listener
        data: success, // status info
        pingData: {
          gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
          cmpStatus: "stub", // possible values: stub, loading, loaded, error
          cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
          signalStatus: "not ready", // possible values: not ready, ready
          supportedAPIs: window.__gpp_supportedAPIs, // list of supported APIs
          cmpId: CMP_ID, // IAB assigned CMP ID, may be 0 during stub/loading
          sectionList: [],
          applicableSections: [],
          gppString: "",
          parsedSections: {},
        },
      },
      true
    );
  } else if (cmd === "hasSection") {
    clb(false, true);
  } else if (cmd === "getSection" || cmd === "getField") {
    clb(null, true);
  }
  //queue all other commands
  else {
    __gpp.queue.push([].slice.apply(b));
  }
};
window.__gpp_msghandler = function (event) {
  var msgIsString = typeof event.data === "string";
  try {
    var json = msgIsString ? JSON.parse(event.data) : event.data;
  } catch (e) {
    var json = null;
  }
  if (typeof json === "object" && json !== null && "__gppCall" in json) {
    var i = json.__gppCall;

    window.__gpp(
      i.command,
      function (retValue, success) {
        var returnMsg = {
          __gppReturn: {
            returnValue: retValue,
            success: success,
            callId: i.callId,
          },
        };
        event.source.postMessage(msgIsString ? JSON.stringify(returnMsg) : returnMsg, "*");
      },
      "parameter" in i ? i.parameter : null,
      "version" in i ? i.version : "1.1"
    );
  }
};
if (!("__gpp" in window) || typeof window.__gpp !== "function") {
  window.__gpp = window.__gpp_stub;
  window.addEventListener("message", window.__gpp_msghandler, false);
  window.__gpp_addFrame("__gppLocator");
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

var __gppEventListenerReturn = __gpp('addEventListener', ( event ) => { 
  
  // console.log( "GPP EVENT" )
  // console.log( event )
  if (event.eventName == "sectionChanged")  {
    ampLogInfo( "GPP sectionChanged " )
    __updateGPPCookie();

    // __gpp("getSection", function (data, success) {
    //   console.log("Here's the tcfeuv2 section...");
    //   console.log(data, success);
    // }, 'tcfeuv2');
    
  }
});


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Startup
//


function __dumptcfping( label ) {
  // console.log( "#x checking for __uspapi() function > " + typeof __uspapi + " (" + label + ")" );
  
  // console.log( "GPP:" + label );
  
  // try {
  // __uspapi = undefined;
  // } catch (e) {
  // }
//   __tcfapi( 'ping', 2, (data, success) => {

//     let objectASString = JSON.stringify(data, null, 2);
//     console.log( 'TCF Ping ' + label + " : " + objectASString );
//     console.log( data );
//     console.log( window.__cmpTCModel );
//     console.log( window.__GVL );
//  } 
//  );

}

// const __tcfeventlistenercallback = (tcData, success) => {
//   let objectASString = JSON.stringify(tcData, null, 2);
//   console.log( "__tcfeventlistenercallback : " + objectASString );
// }

// __tcfapi('addEventListener', 2, __tcfeventlistenercallback );



// @ts-ignore
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

let cmpApi = undefined; // new CmpApi(CMP_ID, CMP_BUILD); 
let tcfCmpApi = undefined; // new TCFCmpApi( CMP_ID, CMP_VERSION, false );

__dumptcfping( "main" );


function startupCMP() {

  __dumptcfping( "startupCMP()" );


  GVL.baseUrl = "https://qd.admetricspro.com/js/gpp/vendor-list-v3/";
  GVL.latestFilename = 'vendor-list.json';   

  window.__GVL = new GVL();    // event handler from this load kicks everything off
  
  __dumptcfping( "Initialized GVL variable" );

  if ( typeof gGDPR_NonTCFVendors == 'undefined' ) {
    gGDPR_NonTCFVendors = [];
  }

  let clearConsent = getParameterByName("ampGPPClear");

  if ( clearConsent ) {
    ampLogInfo( "ampGPPClear present, clearing consent and geolocation" );
    setCookie(  "amp_pieog", "", 7);
    setCookie( CMP_CONSENTCOOKIE, "", 7);
    setCookie(  CMP_GPP_CONSENTCOOKIE, "", 7);

  }

  // console.log(" >>>>>>>> Before CmpApi <<<<<<<<<<<<<<<<<<<");

  var gppResponseFunc = function( tcData, success ) {
    if ( typeof success != "undefined" && success == false ) {      // gpp 1.0 does not have success in callback
        console.log( "CMP error response" )
    } else {
      console.log( tcData );
    }
    }


  // console.log( __gpp( 'ping', gppResponseFunc ) );
  // console.log(" >>>>>>>> SETTING CmpApi <<<<<<<<<<<<<<<<<<<");



  // console.log(" >>>>>>>> After CmpApi <<<<<<<<<<<<<<<<<<<");
  // console.log( __gpp( 'ping', gppResponseFunc ) );
  // console.log(" >>>>>>>>  >>>>><<<<<   <<<<<<<<<<<<<<<<<");

  // window.__gpp = cmpApi;
  
  window.__cmpGetTcfFlavor = function () {
    const tc = getCookie("euconsent-v2") || "";
    const segs = tc ? tc.split(".").length : 0;
    // TCF v2.3 => core + disclosed (>=2). PublisherTC can add more.
    return segs >= 2 ? "2.3" : "2.2";
  };

  function copyModelBlobToModel( modelBlob  ) {

    // console.log( "Creating new TCModel from existing blob");
    __dumptcfping( "copyModelBlobToModel(): begin" );

    // Some TCString methods that are supposed to return TCModel objects don't;
    // what comes back seems to be something like data blob with TCModel's fields
    // but isn't actually a TCModel object. 

    // So right here we've got something that resembles a TCModel in modelBlob,
    // but if we just blindly assign it to window.__cmpTCModel it totally fucks it
    // up in way that causes future calls to encode the consent string to fail
    // with errors deep in the IAB libraries. So what we're going to do here is
    // copy the relevent consent options from modelBlob into __cmpTCModel so
    // that __cmpTCModel is still an actual object with callable methods.

    // This code is super brittle and if the definition of TCModel changes
    // for something like TCF 2.4 or some other future version, we'll need
    // to update the fields here.

    //@ts-ignore
    window.__cmpTCModel.unsetAll();

    //@ts-ignore
    window.__cmpTCModel.lastUpdated = modelBlob.lastUpdated;
    //@ts-ignore
    window.__cmpTCModel.created = modelBlob.created;
    //@ts-ignore
    // Use GVL tcfPolicyVersion if available, otherwise fall back to modelBlob value
    // Do not hardcode to avoid version mismatches
    window.__cmpTCModel.policyVersion = window.__GVL?.tcfPolicyVersion ?? modelBlob.policyVersion;
    //@ts-ignore
    window.__cmpTCModel.consentScreen = modelBlob.consentScreen;
    //@ts-ignore
    // Note: isServiceSpecific will be forced to false by __ensureTcModelConsistencyBeforeEncode()
    window.__cmpTCModel.isServiceSpecific = modelBlob.isServiceSpecific;
    
    //@ts-ignore
    window.__cmpTCModel.publisherCountryCode = modelBlob.publisherCountryCode; 
    //@ts-ignore
    window.__cmpTCModel.vendorLegitimateInterests = modelBlob.vendorLegitimateInterests;
    //@ts-ignore
    window.__cmpTCModel.supportOOB = modelBlob.supportOOB;
    //@ts-ignore
    window.__cmpTCModel.useNonStandardStacks = modelBlob.useNonStandardStacks;
    //@ts-ignore
    window.__cmpTCModel.vendorListVersion = modelBlob.vendorListVersion;
    //@ts-ignore
    window.__cmpTCModel.version = modelBlob.version;

    window.__cmpTCModel.publisherConsents = modelBlob.publisherConsents;
    window.__cmpTCModel.publisherCustomConsents = modelBlob.publisherCustomConsents;
    window.__cmpTCModel.publisherCustomLegitimateInterests = modelBlob.publisherCustomLegitimateInterests;
    window.__cmpTCModel.publisherLegitimateInterests = modelBlob.publisherLegitimateInterests;

    window.__cmpTCModel.purposeConsents = modelBlob.purposeConsents;
    window.__cmpTCModel.purposeLegitimateInterests = modelBlob.purposeLegitimateInterests;
    window.__cmpTCModel.specialFeatureOptins = modelBlob.specialFeatureOptins;
    window.__cmpTCModel.vendorConsents = modelBlob.vendorConsents;
    if (modelBlob && modelBlob.vendorsDisclosed) {
      window.__cmpTCModel.vendorsDisclosed = modelBlob.vendorsDisclosed;
    }

    // Re-populate vendorsDisclosed and ensure policyVersion/isServiceSpecific consistency
    // This is necessary because modelBlob is not a real TCModel instance and may have
    // incomplete or outdated vendorsDisclosed data. We must ensure TCF 2.3 compliance.
    __ensureTcModelConsistencyBeforeEncode();

    __dumptcfping( "copyModelBlobToModel(): end" );

  }



  // This version of geoIPCallback is used when we're fetching the GVL first.
  // The new version is an attempt to refactor the code so that the geo lookup
  // happens first (or uses the cache), and then we only opportunistically
  // load the GVL if we need it. This is to speed up the CMP loading process

    let initTCFAPI = function( ) {
      window.__cmpTCModel = new TCModel( window.__GVL );  
      window.__cmpTCModel.cmpId = CMP_ID;
      window.__cmpTCModel.cmpVersion = CMP_VERSION;
      window.__cmpTCModel.consentScreen = 1;
      // TCF 2.3: Force isServiceSpecific=false to ensure DisclosedVendors segment is included.
      // When isServiceSpecific=true, some encoder implementations omit the DisclosedVendors segment,
      // which is required for TCF 2.3 compliance and modern validators.
      window.__cmpTCModel.isServiceSpecific = false;
      window.__cmpTCModel.policyVersion = window.__GVL?.tcfPolicyVersion ?? 5;
      window.__cmpTCModel.publisherCountryCode = typeof gGDPR_publisherCountryCode != 'undefined' ? gGDPR_publisherCountryCode : 'US';
    
      tcfCmpApi.tcModel = window.__cmpTCModel;
      tcfCmpApi.tcModel.cmpId = CMP_ID;
      tcfCmpApi.tcModel.cmpVersion = CMP_VERSION;
    }


    let geoIPCallback = function( status: boolean, country : string, region : string ) {
      if ( ! status ) {
        ampLogError( "Error getting visitor country and region");
        return;
      } 

      __dumptcfping( "__tcfapi start of geo callback" );

      cmpApi = new CmpApi(CMP_ID, CMP_BUILD); 
      tcfCmpApi = new TCFCmpApi( CMP_ID, CMP_VERSION, false );
      window.cmpApi = cmpApi;
      window.__cmpApi = cmpApi;
      const __cmpApiOriginalFireEvent = cmpApi.fireEvent.bind(cmpApi);
      cmpApi.fireEvent = function( eventName: string, ...args: any[] ) {
        const result = __cmpApiOriginalFireEvent( eventName, ...args );
        if ( eventName != 'sectionChanged' ) {
          return result;
        }

        __updateGPPCookie();
        return result;
      };

      cmpApi.setSupportedAPIs( window.__gpp_supportedAPIs );

      let tcfConsentString = getCookie( CMP_CONSENTCOOKIE );

      let consentString = __getGPPCookie( );

      let forceRejectAllNoConsent = false;

      if (consentString ) {
        ampLogInfo( "Initializing with existing GPP consent string: " + consentString);
        cmpApi.setGppString(consentString);
      } else 		if ( typeof( gGDPR_silentNoConsent ) !== "undefined" && gGDPR_silentNoConsent ) {
        ampLogInfo( "gGDPR_silentNoConsent is set; initializing with no consent");
        forceRejectAllNoConsent = true;
        cmpApi.clear();
      }

      else {
        ampLogInfo( "No exisiting consent found, clearing GPP consent string");
        cmpApi.clear();
      }

      cmpApi.setCmpStatus( "loaded" );

      let forcedCountryCode = getParameterByName("ampGPPCMPCC");
      let forcedRegionCode = getParameterByName("ampGPPCMPRegion");

      if ( forcedCountryCode )
        country = forcedCountryCode
      
      if ( forcedRegionCode )
        region = forcedRegionCode
        
      ampLogInfo( "Visitor country: " + country + " region: " + region );

      const gdprApplies = isGDPRCountry( country  );
      const isUSA = country == "US";

      ampLogInfo( "GDPR " + ( gdprApplies ? "applies." : "does not apply." ) );

      // GPC (Global Privacy Control) Detection
      // Check if the user's browser has GPC enabled, which indicates they want to opt-out
      // of data sales, sharing, and targeted advertising
      const gpc = isGpcEnabled();
      ampLogInfo( "GPC (Global Privacy Control) " + ( gpc ? "IS ENABLED" : "is not enabled" ) );

      cmpApi.setSignalStatus( "not ready" );

      nextTick( () => {
        // console.log( "__cmpOpenUI():  nextTick" );

        let initalLayer = "";
        let openCMP = false;

        if (gdprApplies) {

          // make sure the GVL got loaded before we keep going here...

          window.__GVL.readyPromise.then( () => { 
            // @ts-ignore
            ampLogInfo( "GVL version is " + window.__GVL.vendorListVersion)
            // console.log( "#2 checking for __uspapi() function > " + typeof __uspapi );
      
            initTCFAPI();

            initalLayer = "layerOne";
            cmpApi.setApplicableSections( [ TcfEuV2.ID ] );
  
            if ( cmpApi.hasSection( 'tcfeuv2') ) {
              ampLogInfo( "GDPR TCF EU V2.x Privacy Data Present, initializing without opening CMP UI");
              openCMP = false;
  
              // get the current GVL version
  
              let gvlVersion = window.__GVL.vendorListVersion;
  
  
              // console.log( "Decoding tcf consent string into model...");
              let tcModelBlob = TCString.decode(tcfConsentString, window.__GVL );
              copyModelBlobToModel( tcModelBlob );
              // __dumptcfping( "geoIPCallback: BEFORE DECODE @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@" );
  
              // window.__cmpTCModel = TCString.decode(tcfConsentString, window.__GVL );
  
              __dumptcfping( "geoIPCallback: AFTER DECODE" );
  
              // get the GVL version out of the tcModelBlob
              
              let existingConsentVendorVersion = tcModelBlob.vendorListVersion;
  
              if ( existingConsentVendorVersion != gvlVersion ) {
                ampLogInfo( "Found old GVL Version in existing consent, forcing CMP UI to open");
                openCMP = true;
              }
  
              tcfCmpApi.update(tcfConsentString, false); // not showing the ui to the user
  
              __dumptcfping( " geo callback gdprApplies, tcfeuv2 present" );
  
            } else {
              __dumptcfping( " geo callback gdprApplies, missing tcfeuv2 (before update)" );
  
              if (tcfConsentString != "") {
                // console.log( "Decoding tcf consent string into model (2)...");
  
                let tcModelBlob = TCString.decode(tcfConsentString, window.__GVL );
                copyModelBlobToModel( tcModelBlob );
  
              }
              tcfCmpApi.update(tcfConsentString, true); // showing the ui to the user
  
              __dumptcfping( " geo callback gdprApplies, missing tcfeuv2 (after update)" );
  
              openCMP = true;
            }       

            let initialVisible = true;
            if ( forceRejectAllNoConsent ) {
              __storeRejectAllTCString();
              cmpApi.setSignalStatus( "ready" );
              cmpApi.fireEvent( 'signalStatus', 'ready' );
              initalLayer = "close";
              initialVisible = false;
            } else if ( gpc ) {
              // GPC is enabled for GDPR region: Apply conservative "Reject All" approach
              // When GPC is on, we treat it as an explicit opt-out signal and do not show UI
              ampLogInfo( "GPC enabled in GDPR region: applying Reject All consent" );
              __storeRejectAllTCString();
              cmpApi.setSignalStatus( "ready" );
              cmpApi.fireEvent( 'signalStatus', 'ready' );
              initalLayer = "close";
              initialVisible = false;
            } else if ( openCMP )
              cmpApi.setSignalStatus( "not ready" );
            else {
              cmpApi.setSignalStatus( "ready" );
              cmpApi.fireEvent( 'signalStatus', 'ready' );
            }

            let props =  {
              initialVisible: initialVisible,
              reopenLayer:initalLayer,
              initialLayer:openCMP ? initalLayer : "close",
              cmpApi: cmpApi,
              storeTCString: __storeTCString,
              storeAcceptAllTCString: __storeAcceptAllTCString,
              storeRejectAllTCString: __storeRejectAllTCString,
            }

            __dumptcfping( " creating app for GDPR" );
  
            __gppAppInstance = createApp( App, props ).mount('#' + __gppMountDivID);
            
            // Expose for debugging
            window.__gppAppInstance = __gppAppInstance;
  

        } );   // end of GVL.readyPromise.then()
      


        } else {


          window.__GVL.readyPromise.then( () => { 
            // @ts-ignore
            ampLogInfo( "GVL version is " + window.__GVL.vendorListVersion)
            // console.log( "#2 checking for __uspapi() function > " + typeof __uspapi );
      
            initTCFAPI();
            tcfCmpApi.update(null); // GDPR does not apply

          });


          function test( regiontoTest, stateName, cmpSection, cmpSectionID, cmpDisplayLayer, grantConsentFunc, forceRejectAllNoConsent ) {
            if ( isUSA && (region == regiontoTest) ) {
              initalLayer = cmpDisplayLayer;

              cmpApi.setApplicableSections( [ cmpSectionID ] );

              if ( cmpApi.hasSection( cmpSection ) ) {
                ampLogInfo( stateName + " Privacy Data Present, initializing from stored consent");
                
                // GPC: If GPC is enabled, apply opt-out preferences even if consent exists
                // This ensures GPC signal is honored and overrides previous consent
                if ( gpc ) {
                  ampLogInfo( "GPC enabled: applying opt-out to " + stateName + " section" );
                  applyGpcToUsSections( cmpApi, region );
                  __updateGPPCookie();
                }
                
                cmpApi.setSignalStatus( "ready" );
                cmpApi.fireEvent( 'signalStatus', 'ready' );
                openCMP = false;
              } else {
                if ( forceRejectAllNoConsent ) {
                  ampLogInfo( stateName + " Privacy Data Not Present, initializing with no consent");
                  grantConsentFunc( false, cmpApi, true, true );
                } else if ( gpc ) {
                  // GPC: When GPC is enabled and no prior consent exists, apply opt-out
                  // Do NOT show the CMP UI - GPC is an automatic opt-out signal
                  ampLogInfo( "GPC enabled: initializing " + stateName + " with opt-out (no UI)" );
                  grantConsentFunc( false, cmpApi, true, true );
                  applyGpcToUsSections( cmpApi, region );
                  __updateGPPCookie();
                } else {
                  ampLogInfo( stateName + " Privacy Data Not Present, initializing with default consent");
                  // grantConsentFunc( true, cmpApi, true, true );
                }

                cmpApi.setSignalStatus( "ready" );
                cmpApi.fireEvent( 'signalStatus', 'ready' );
                openCMP = true;
              }       
            }
          }

          ampLogInfo('region:' + region + ' isUSA:' + isUSA);
          
          test( "CA", "California", UsCaV1.NAME, UsCaV1.ID, "layerStateCalifornia", updateCMPCalifornia, forceRejectAllNoConsent );
          test( "CO", "Colorado", UsCoV1.NAME, UsCoV1.ID, "layerStateColorado", updateCMPColorado, forceRejectAllNoConsent );
          test( "CT", "Connecticut", UsCtV1.NAME, UsCtV1.ID, "layerStateConnecticut", updateCMPConnecticut, forceRejectAllNoConsent );
          test( "DE", "Delaware", UsDe.NAME, UsDe.ID, "layerStateDelaware", updateCMPDelaware, forceRejectAllNoConsent );
          test( "IA", "Iowa", UsIa.NAME, UsIa.ID, "layerStateIowa", updateCMPIowa, forceRejectAllNoConsent );
          test( "MT", "Montana", UsMt.NAME, UsMt.ID, "layerStateMontana", updateCMPMontana, forceRejectAllNoConsent );
          test( "NE", "Nebraska", UsNe.NAME, UsNe.ID, "layerStateNebraska", updateCMPNebraska, forceRejectAllNoConsent );
          test( "NH", "NewHampshire", UsNh.NAME, UsNh.ID, "layerStateNewHampshire", updateCMPNewHampshire, forceRejectAllNoConsent );
          test( "NJ", "NewJersey", UsNj.NAME, UsNj.ID, "layerStateNewJersey", updateCMPNewJersey, forceRejectAllNoConsent );
          test( "OR", "Oregon", UsOr.NAME, UsOr.ID, "layerStateOregon", updateCMPOregon, forceRejectAllNoConsent );
          test( "TN", "Tennessee", UsTn.NAME, UsTn.ID, "layerStateTennessee", updateCMPTennessee, forceRejectAllNoConsent );
          test( "TX", "Texas", UsTx.NAME, UsTx.ID, "layerStateTexas", updateCMPTexas, forceRejectAllNoConsent );
          test( "UT", "Utah", UsUtV1.NAME, UsUtV1.ID, "layerStateUtah", updateCMPUtah, forceRejectAllNoConsent );
          test( "VA", "Virginia", UsVaV1.NAME, UsVaV1.ID, "layerStateVirginia", updateCMPVirginia, forceRejectAllNoConsent );
          
        }

        console.log( ">>>>> CMP(): initalLayer = " + initalLayer + " openCMP = " + openCMP + " forceRejectAllNoConsent = " + forceRejectAllNoConsent);


        if ( initalLayer ) {   
          let props =  {
            initialVisible: true,
            reopenLayer:initalLayer,
            initialLayer:openCMP ? initalLayer : "close",
            cmpApi: cmpApi,
            storeTCString: __storeTCString,
            storeAcceptAllTCString: __storeAcceptAllTCString,
            storeRejectAllTCString: __storeRejectAllTCString,
          }
          __dumptcfping( " creating app" );

          __gppAppInstance = createApp( App, props ).mount('#' + __gppMountDivID);
          
          // Expose for debugging
          window.__gppAppInstance = __gppAppInstance;

          if ( openCMP )
            cmpApi.setSignalStatus( "not ready" );
          else {
            cmpApi.setSignalStatus( "ready" );
            cmpApi.fireEvent( 'signalStatus', 'ready' );
          }

          // @ts-ignore
          // tcfCmpApi.update("", true);   // on initial open, assume no existing string, otherwise we wouldn't be here...


        } else {
          let props =  {
            initialVisible: false,
            reopenLayer:"layerNoConsent",
            initialLayer:"close",
            cmpApi: cmpApi,
            storeTCString: __storeTCString,
            storeAcceptAllTCString: __storeAcceptAllTCString,
            storeRejectAllTCString: __storeRejectAllTCString,
          }

          __dumptcfping( " creating app (no applicable sections)" );
          __gppAppInstance = createApp( App, props ).mount('#' + __gppMountDivID);
          
          // Expose for debugging
          window.__gppAppInstance = __gppAppInstance;

          cmpApi.setSignalStatus( "ready" );
          cmpApi.fireEvent( 'signalStatus', 'ready' );
        }
      } );
    }


    // this kicks everything off...

    getVisitorCountryAndRegion( geoIPCallback );


    /* ========

    This is the old implementation that waited for the GVL to be ready before kicking off the
    the geolookup and doing the CMP initialization. The new implementation does the geolookup
    first and only waits on the the GVL promise if we're in a GDPR country.

    let geoIPCallback_old = function( status: boolean, country : string, region : string ) {
      if ( ! status ) {
        ampLogError( "Error getting visitor country and region");
        return;
      } 

      __dumptcfping( "__tcfapi start of geo callback" );

      cmpApi = new CmpApi(CMP_ID, CMP_BUILD); 
      tcfCmpApi = new TCFCmpApi( CMP_ID, CMP_VERSION, false );
      
      tcfCmpApi.tcModel = window.__cmpTCModel;
      tcfCmpApi.tcModel.cmpId = CMP_ID;
      tcfCmpApi.tcModel.cmpVersion = CMP_VERSION;

      cmpApi.setSupportedAPIs( window.__gpp_supportedAPIs );

      let tcfConsentString = getCookie( CMP_CONSENTCOOKIE );

      let consentString = __getGPPCookie( );

      if (consentString ) {
        ampLogInfo( "Initializing with existing GPP consent string: " + consentString);
        cmpApi.setGppString(consentString);
      }
      else {
        ampLogInfo( "No exisiting consent found, clearing GPP consent string");
        cmpApi.clear();
      }

      cmpApi.setCmpStatus( "loaded" );

      let forcedCountryCode = getParameterByName("ampGPPCMPCC");
      let forcedRegionCode = getParameterByName("ampGPPCMPRegion");

      if ( forcedCountryCode )
        country = forcedCountryCode
      
      if ( forcedRegionCode )
        region = forcedRegionCode
        
     ampLogInfo( "Visitor country: " + country + " region: " + region );

      const gdprApplies = isGDPRCountry( country  );
      const isUSA = country == "US";

      ampLogInfo( "GDPR " + ( gdprApplies ? "applies." : "does not apply." ) );

      nextTick( () => {
        // console.log( "__cmpOpenUI():  nextTick" );

        let initalLayer = "";
        let openCMP = false;

        if (gdprApplies) {
          initalLayer = "layerOne";
          cmpApi.setApplicableSections( [ TcfEuV2.ID ] );

          if ( cmpApi.hasSection( 'tcfeuv2') ) {
            ampLogInfo( "GDPR TCF EU V2.x Privacy Data Present, initializing without opening CMP UI");
            cmpApi.setSignalStatus( "ready" );
            cmpApi.fireEvent( 'signalStatus', 'ready' );
            openCMP = false;

            // get the current GVL version

            let gvlVersion = window.__GVL.vendorListVersion;


            // console.log( "Decoding tcf consent string into model...");
            let tcModelBlob = TCString.decode(tcfConsentString, window.__GVL );
            copyModelBlobToModel( tcModelBlob );
            // __dumptcfping( "geoIPCallback: BEFORE DECODE @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@" );

            // window.__cmpTCModel = TCString.decode(tcfConsentString, window.__GVL );

            __dumptcfping( "geoIPCallback: AFTER DECODE" );

            // get the GVL version out of the tcModelBlob
            
            let existingConsentVendorVersion = tcModelBlob.vendorListVersion;

            if ( existingConsentVendorVersion != gvlVersion ) {
              ampLogInfo( "Found old GVL Version in existing consent, forcing CMP UI to open");
              openCMP = true;
            }

            tcfCmpApi.update(tcfConsentString, false); // not showing the ui to the user

            __dumptcfping( " geo callback gdprApplies, tcfeuv2 present" );

          } else {
            __dumptcfping( " geo callback gdprApplies, missing tcfeuv2 (before update)" );

            if (tcfConsentString != "") {
              // console.log( "Decoding tcf consent string into model (2)...");

              let tcModelBlob = TCString.decode(tcfConsentString, window.__GVL );
              copyModelBlobToModel( tcModelBlob );

            }
            tcfCmpApi.update(tcfConsentString, true); // showing the ui to the user

            __dumptcfping( " geo callback gdprApplies, missing tcfeuv2 (after update)" );

            openCMP = true;
          }       


        } else {
          tcfCmpApi.update(null); // GDPR does not apply

          function test( regiontoTest, stateName, cmpSection, cmpSectionID, cmpDisplayLayer, grantConsentFunc ) {
            if ( isUSA && (region == regiontoTest) ) {
              initalLayer = cmpDisplayLayer;

              cmpApi.setApplicableSections( [ cmpSectionID ] );

              if ( cmpApi.hasSection( cmpSection ) ) {
                ampLogInfo( stateName + " Privacy Data Present, initializing from stored consent");
                cmpApi.setSignalStatus( "ready" );
                cmpApi.fireEvent( 'signalStatus', 'ready' );
                openCMP = false;
              } else {
                ampLogInfo( stateName + " Privacy Data Not Present, initializing with default consent");
                grantConsentFunc( true, cmpApi, true );
                cmpApi.setSignalStatus( "ready" );
                cmpApi.fireEvent( 'signalStatus', 'ready' );
                openCMP = false;
              }       
            }
          }
  
          test( "CA", "California", UsCaV1.NAME, UsCaV1.ID, "layerStateCalifornia", updateCMPCalifornia );
          test( "CO", "Colorado", UsCoV1.NAME, UsCoV1.ID, "layerStateColorado", updateCMPColorado );
          test( "CT", "Connecticut", UsCtV1.NAME, UsCtV1.ID, "layerStateConnecticut", updateCMPConnecticut );
          test( "UT", "Utah", UsUtV1.NAME, UsUtV1.ID, "layerStateUtah", updateCMPUtah );
          test( "VA", "Virginia", UsVaV1.NAME, UsVaV1.ID, "layerStateVirginia", updateCMPVirginia );
  
          }

          // console.log( ">>>>> CMP(): initalLayer = " + initalLayer + " openCMP = " + openCMP );

        if ( initalLayer ) {
          let props =  {
            initialVisible: true,
            reopenLayer:initalLayer,
            initialLayer:openCMP ? initalLayer : "close",
            cmpApi: cmpApi,
            storeTCString: __storeTCString,
            storeAcceptAllTCString: __storeAcceptAllTCString,
            storeRejectAllTCString: __storeRejectAllTCString,
          }
          __dumptcfping( " creating app" );

          __gppAppInstance = createApp( App, props ).mount('#' + __gppMountDivID);
          
          // Expose for debugging
          window.__gppAppInstance = __gppAppInstance;


          // @ts-ignore
          // tcfCmpApi.update("", true);   // on initial open, assume no existing string, otherwise we wouldn't be here...


        } else {
          cmpApi.setSignalStatus( "ready" );
          cmpApi.fireEvent( 'signalStatus', 'ready' );
        }
      } );
    }

    window.__GVL.readyPromise.then( () => { 
      // @ts-ignore
      ampLogInfo( "GVL version is " + window.__GVL.vendorListVersion)
      // console.log( "#2 checking for __uspapi() function > " + typeof __uspapi );


      window.__cmpTCModel = new TCModel( window.__GVL );  
      window.__cmpTCModel.cmpId = CMP_ID;
      window.__cmpTCModel.cmpVersion = CMP_VERSION;
      window.__cmpTCModel.consentScreen = 1;
      window.__cmpTCModel.isServiceSpecific = true;
      window.__cmpTCModel.publisherCountryCode = typeof gGDPR_publisherCountryCode != 'undefined' ? gGDPR_publisherCountryCode : 'US';
    
      
      __dumptcfping( " gvl ready" );

      // @ts-ignore
      // const encodedString = TCString.encode(window.__cmpTCModel);
      // ampLogInfo( encodedString);

      getVisitorCountryAndRegion( geoIPCallback_old );
      __dumptcfping( " returned from geoIP" );

  } ); 

 ======== */

}




ampLogInfo( "AdMetricsPro GPP CMP v" + CMP_BUILD) 

  // console.log( "#1 checking for __uspapi() function > " + typeof __uspapi );

function doStartup() {
  ampLogInfo( "AdMetricsPro GPP CMP Startup...");
  __injectDOMElements( );
  startupCMP();
}

// if document state is complete, start the CMP, otherwise wait for it to be ready

if (document.readyState === 'complete') {
  doStartup();
} else {
  window.addEventListener('load', doStartup);
}




    // cmpApi.setGppString(gppString);


//     if ( ! cookie ) {
//       console.log( "CMP: GDPR applies and no existing consent")
//       targetLayer = "layerOne";
//     } else if ( needNewConsent ) {
//       console.log( "CMP: consent out dated, requesting new consent")
//       targetLayer = "layerOne";
//     }
//     else     
//       console.log( "CMP: GDPR applies, using existing consent")
//   }
//   else
//   {
//     console.log( "CMP: GDPR does not apply ")
//     cmpApi.update(null);
//   }

